const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "page/dashboard" */'@/views/pages/dashboard/Dashboard.vue')
  }
]

export default routes
